import { render, staticRenderFns } from "./channel-item.vue?vue&type=template&id=39e76706&scoped=true&lang=pug"
import script from "./channel-item.vue?vue&type=script&lang=js"
export * from "./channel-item.vue?vue&type=script&lang=js"
import style0 from "./channel-item.vue?vue&type=style&index=0&id=39e76706&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e76706",
  null
  
)

export default component.exports